import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Checkbox, Col, Row } from 'antd';
import { Step } from '../../services/util/step-manager/types/Step';
import { StepEnum } from '../../services/util/step-manager/enum/StepEnum';
import AdmissionMetadata from '../../types/AdmissionMetadata';
import dayjs from 'dayjs';
import usersRepository from '../../services/repository/users';

const TitleFinalization = styled.h2`
    text-align: center;
    margin-bottom: 32px;
`;

const ChkAware = styled(Checkbox)`
    margin-top: 32px;
`;

const ButtonCol = styled(Col)`
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
`;

type Props = {
  handleAdmissionFinalization: () => void,
  currentStep: Step,
}

function finalizationCompleteMessage(_: Props, username: string) {
  return (
    <>
      <TitleFinalization>Olá {username}, agora é com a gente!</TitleFinalization>
      <ul>
        <li>Vamos concluir a admissão. Ao finalizar seu cadastro no nosso sistema, você receberá uma notificação ou o
          responsável pelo processo entrará em contato.
        </li>
        <li>Caso ainda tenha dúvidas sobre a admissão ou precise adicionar/editar alguma informação do cadastro, entre
          em contato com o responsável pelo seu processo.
        </li>
      </ul>
    </>
  );
}

function finalizationConfirmationMessage(props: Props, username: string, chkAware: boolean, setChkAware: React.Dispatch<React.SetStateAction<boolean>>) {
  return (
    <>
      <TitleFinalization>Olá {username}, vamos finalizar seu processo?</TitleFinalization>
      <ul>
        <li>
          Depois de enviar as informações, você não poderá realizar nenhuma alteração/edição dos dados inseridos no
          processo de admissão.
        </li>
        <li>
          Se for necessário corrigir/acrescentar alguma informação, por favor contate a pessoa responsável por seu
          processo de admissão.
        </li>
        <li>
          Em caso de divergência de alguma informação do cadastro com os do sistema, a pessoa responsável pelo processo
          de admissão entrará em contato para solicitar os dados corretos.
        </li>
        <li>
          A partir deste momento, a pessoa do setor responsável irá prosseguir com o cadastro das informações e, por
          isso, nenhuma alteração por meio do colaborador será permitida.
        </li>
        <li>
          O setor responsável pelo processo admissional irá utilizar seus dados e documentos anexados para concluir seu
          cadastro no sistema.
        </li>
      </ul>

      <ChkAware checked={chkAware} onChange={(e) => setChkAware(e.target.checked)}>Estou ciente e de acordo com os
        termos acima.</ChkAware>

      <Row>
        <ButtonCol span={24}>
          <Button type='primary' onClick={props.handleAdmissionFinalization} disabled={!chkAware}>Finalizar e
            Enviar</Button>
        </ButtonCol>
      </Row>
    </>
  );
}

const FinalizationConfirmation: React.FC<Props> = ({ handleAdmissionFinalization, currentStep }) => {
  const [chkAware, setChkAware] = useState(false);
  const [admissionMetadata, setAdmissionMetadata] = useState<AdmissionMetadata>({
    id: '',
    name: '',
    socialName: '',
    email: '',
    cpf: '',
    createdAt: dayjs(),
    professionalIdentification: 0,
  });

  useEffect(() => {
    usersRepository.getCurrentUserAdmissionMetaData().then(data => {
      setAdmissionMetadata(data);
    });
  }, []);

  const username = admissionMetadata?.socialName || admissionMetadata?.name || '';
  if (currentStep.id === StepEnum.FINALIZATION_CONFIRMATION) {
    return finalizationConfirmationMessage({
      handleAdmissionFinalization,
      currentStep,
    }, username, chkAware, setChkAware);
  }

  if (currentStep.id === StepEnum.FINALIZATION) {
    return finalizationCompleteMessage({ handleAdmissionFinalization, currentStep }, username);
  }

  throw new Error('Erro na renderização de componente. Entre em contato com o administrador do sistema');
};

export default FinalizationConfirmation;
